import { Badge } from '@material-ui/core';
import styled, { keyframes } from 'styled-components';

const blink = keyframes`
  from { opacity: 1; }
  to { opacity: 0; }
`;

export const WrapperBadge = styled(Badge)`
  margin-right: 2rem;
  cursor: pointer;

  span.MuiBadge-badge {
    animation: ${blink} 1.5s ease infinite;
  }
`;

export const WrapperDrawer = styled.div`
  height: 50vh;

  display: flex;
  flex-direction: column;

  @media (max-width: 425px) {
    height: 100vh;
  }
`;

export const DrawerHeader = styled.div`
  display: flex;
  align-items: center;

  padding: 1rem 2rem;
  margin-top: 7rem;

  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
`;

export const WrapperContent = styled.div`
  flex: 1;
  margin: 1rem;
  overflow-y: auto;
`;
